import React from 'react'
import { truncateText } from '../hooks/TextVeiw'
import {Link} from "react-router-dom"
import {IoIosArrowBack ,IoIosArrowForward} from "../icons"
import { useTranslation } from 'react-i18next'
import { useStateContext } from '../../context/ContextProvider'
const P_samall_card = ({card}) => {
  const {t}=useTranslation()
  const {currentLang}=useStateContext()
  const isAr =currentLang==="ar"
  const title =isAr ?card.title_Ar :card.title_En

  return (
    <div className=' flex flex-row w-full gap-5 bg-light-glass2 dark:bg-dark-glass2 border border-light-glassStrock2 dark:border-dark-glassStrock1 shadow-md backdrop-blur-xl items-center rounded-lg justify-center p-2 h-[120px] overflow-hidden'>
        <div className="w-3/5 h-full overflow-hidden bg-light-secondary  rounded-md ">
        <img src={card.image} className='w-full' />
        </div>
    
     <div className="flex flex-col  justify-between py-4 items-start w-2/5 h-full ">

<h6 className='h6 text-light-subtitle dark:text-dark-subtitle'>{truncateText(title ,4 )}</h6>
<Link   to={`/Products_Details/${card.id}`}
            state= {{ cardData: card }}   
            onClick={() => {
                window.scrollTo(0, 0);
              }}
          >
  <button className=' transition delay-150 duration-300 ease-in-out ltr:hover:translate-x-4 rtl:hover:-translate-x-4 hover:scale-110
          text-light-link dark:text-dark-link flex flex-row items-center text-sm font-kufi gap-2 '>
  
    <span>  {t("Reade more")}</span>
    <span>  {isAr   ? <IoIosArrowBack size={18}/>: <IoIosArrowForward size={18} />}</span>
  </button>
</Link>
     </div>
    </div>
  )
}

export default P_samall_card